import _ from "lodash";
import TableReportHelper from "report/helper";

export default function apontamentoPontosAmostradosReport(visita, indicador, apontamento, paramItems, unit, indicadorType) {
    // console.log("indicadorType ", indicadorType);
    if (_.isEmpty(paramItems)) {
        return null;
    }



    const h = new TableReportHelper(apontamento);
    const IndicadorClass = indicador.constructor;
    // console.log("IndicadorClass ", IndicadorClass);
    const pontosAmostrados = IndicadorClass.calcPontosAmostrados(apontamento, paramItems);

    const content = [];
    let total = 0;

    for (const ponto of pontosAmostrados) {
        total += ponto.count;

        content.push(
            h.row(
                !_.isEmpty(ponto.intervaloMin) ? h.text(ponto.sinalIntervaloMin) : h.empty(),
                !_.isEmpty(ponto.intervaloMin) ? h.text(`${ponto.intervaloMin} ${unit}`) : h.empty(),

                !_.isEmpty(ponto.intervaloMax) ? h.text(ponto.sinalIntervaloMax) : h.empty(),
                !_.isEmpty(ponto.intervaloMax) ? h.text(`${ponto.intervaloMax} ${unit}`) : h.empty(),

                h.text(ponto.classificacao),
                h.text(ponto.count, { alignment: "center" })
            )
        );
    }

    return h.unbreakable([
        h.panel(
            [
                // prettier-ignore
                h.row(
                    h.title("Pontos Amostrados"),
                    h.title("Classificação"),
                    h.title("Resultado"),
                ),
            ],
            { widths: [185, "*", 70] }
        ),

        h.panel(content, { widths: [15, 65, 15, 65, "*", 70] }),

        h.panel(
            [
                h.row(
                    h.title("Total de Pontos Amostrados", { alignment: "right" }),
                    h.title(total, { alignment: "center" })
                ),
            ],
            { widths: ["*", 70] }
        ),
    ]);
}
